import { TextAreaWithButtons } from "./TextAreaWithButtons";
export default TextAreaWithButtons;
